<template>
    <b-row id="dashboard_panel_component"
           class="dashboard-panel-component">
        <b-col :lg="packet.size.lg"
               :cols="packet.size.sm"
               v-for="(packet, index) in packets"
               :key="index"
               v-if="index > 0">
            <div class="dashboard-panel-element"
                 :class="{ 'content-center' : packet.size.lg === 12 }"
                 @click="!loader && !packet.disable ? buyPacket(index) : ''">
                <div class="dashboard-panel-element--gradient"></div>
                <div class="dashboard-panel-element-value">
                    <span class="dashboard-panel-element-value--sign">{{ packet.sign }}</span>{{ packet.label }}
                </div>
                <p class="dashboard-panel-element-buy" :class="{ 'disabled': packet.disable}">Buy</p>
                <div class="dashboard-panel-element-stars">
                    <i class="mdi mdi-star" v-for="(star, starId) in 7" :class="{ 'active' : packet.stars >= star }" :key="starId"></i>
                </div>
                <div class="dashboard-panel-element-power">
                    Power: {{ packet.power }}
                </div>
                <div class="dashboard-panel-element-digger"
                     :class="'dashboard-panel-element-digger-background-' + index"></div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        dependencies: ['packet'],
        data () {
            return {
                loader: false,
                packets: {
                    100: {
                        label: '100',
                        sign: '$' ,
                        stars: 1,
                        power: 1,
                        size: {
                            lg: 4,
                            sm: 6
                        },
                        disable: true
                    },
                    250: {
                        label: '250',
                        sign: '$' ,
                        stars: 2,
                        power: 3,
                        size: {
                            lg: 4,
                            sm: 6
                        },
                        disable: true
                    },
                    500: {
                        label: '500',
                        sign: '$' ,
                        stars: 3,
                        power: 7,
                        size: {
                            lg: 4,
                            sm: 6
                        },
                        disable: true
                    },
                    1000: {
                        label: '1 000',
                        sign: '$' ,
                        stars: 4,
                        power: 15,
                        size: {
                            lg: 4,
                            sm: 6
                        },
                        disable: true
                    },
                    5000: {
                        label: '5 000',
                        sign: '$' ,
                        stars: 5,
                        power: 80,
                        size: {
                            lg: 4,
                            sm: 6
                        },
                        disable: true
                    },
                    10000: {
                        label: '10 000',
                        sign: '$' ,
                        stars: 6,
                        power: 180,
                        size: {
                            lg: 4,
                            sm: 6
                        },
                        disable: true
                    },
                    25000: {
                        label: '25 000',
                        sign: '$' ,
                        stars: 7,
                        power: 500,
                        size: {
                            lg: 12,
                            sm: 12
                        },
                        disable: true
                    }
                }
            }
        },
        methods: {
            buyPacket (index) {
                this.packet.create(index)
                this.$store.commit('modals', {
                    modal: 'buyPacket',
                    data: {
                        visible: true,
                        message: 'Are you sure you want to buy this package?',
                        packet: this.packet
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .dashboard-panel-component{
        margin: 50px -15px;
    }

    .dashboard-panel-element {
        transition: 200ms all linear;
        height: 150px;
        margin-bottom: 30px;
        position: relative;
        overflow: hidden;
        border-radius: 5px;
        background: $white;
        -webkit-box-shadow: 10px 10px 20px 0 rgba(0,0,0,0.12);
        box-shadow: 10px 10px 20px 0 rgba(0,0,0,0.12);
        cursor: pointer;
        &-buy {
            position: absolute;
            bottom: 10px;
            right: 10px;
            text-transform: uppercase;
            font-size: 16px;
            font-weigt: bold;
            transition: 200ms all linear;
            &.disabled {
                color: #274c874f!important;
            }
        }
        &-value {
            position: absolute;
            top: 10px;
            right: 10px;
            color: $white;
            font-size: 32px;
            font-weight: bold;
            line-height: 1.2;
            &--sign {
                font-size: 16px;
                vertical-align: top;
                line-height: 25px;
            }
        }
        &-stars {
            position: absolute;
            top: 10px;
            left: 10px;
            i {
                color: $white;
                opacity: .3;
                &.active {
                    opacity: 1;
                }
            }

        }
        &-digger {
            position: absolute;
            bottom: 30px;
            left: 10px;
            width: 200px;
            height: 120px;
            background-image: url('../../../../../../assets/img/diggers.png');
            &-background-100 { background-position: 2px 67px }
            &-background-250 { background-position: -199px 62px }
            &-background-500 { background-position: -399px 60px }
            &-background-1000 { background-position: 0px -142px }
            &-background-5000 { background-position: -200px -143px }
            &-background-10000 { background-position: -399px -163px }
            &-background-25000 { background-position: 0px -379px }
        }
        &-power {
            position: absolute;
            bottom: 10px;
            left: 10px;
            font-weight: bold;
            font-size: 12px;
            color: $white;
        }
        &--gradient {
            width: 165%;
            height: 200%;
            background: #000;
            position: absolute;
            bottom: 0;
            right: 0;
            border-radius: 190px/110px;
            -webkit-box-shadow: 0 0 40px 0 rgba(0,0,0,0.6);
            box-shadow: 0 0 40px 0 rgba(0,0,0,0.5);
            background: linear-gradient(135deg, $base2 40%, $base1 100%);
            transition: 200ms all linear;
        }
        &:hover {
            .dashboard-panel-element--gradient {
                right: -90px;
                bottom: -90px;
            }
            .dashboard-panel-element-buy {
                color: $white;
            }
        }
        &.content-center {
            .dashboard-panel-element-digger {
                left: 50%;
                margin-left: -80px;
            }
            .dashboard-panel-element-power {
                left: 50%;
                margin-left: -30px;
            }
        }
    }

    .dashboard-panel-element-link {
        display: inline-block;
        background-color: rgba(0, 0, 0, 0);
        color: $white;
        font-size: 18px;
        line-height: 1.2;
        font-weight: bold;
        text-transform: uppercase;
        margin-top: 30px;
        padding: 8px 20px;
        border: 2px solid $white;
        float: right;
        cursor: pointer;

        &:hover,
        &:focus{
        outline: none;
         }
    }

    @media(max-width: 991px) {
        .start-packet-update {
            &-stars {
                display: none;
            }
            &-digger {
                transform: scale(0.6);
                left: -30px;
                bottom: 5px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/dashboard-first-time/DashboardPackets.vue